import React from 'react';
import { connect } from 'react-redux';

import * as bucketConstants from '../../constants/buckets';
import * as bucketMembersSelectors from '../../selectors/bucketMembersSelectors';
import * as bucketSelectors from '../../selectors/bucketSelectors';

import AddBucketMembers from './AddBucketMembers';
import MembersActions from '../../components/members/MembersActions';

const BucketMembersActions = props => {
    const { isAdmin, ...rest } = props;

    const adminAction = isAdmin ? <AddBucketMembers /> : null;
    return <MembersActions {...rest} adminAction={adminAction} />;
};

const mapStateToProps = state => ({
    searchTerm: bucketMembersSelectors.getBucketMembersSearchTerm(state),
    isAdmin: bucketSelectors.getIsCurrentUserAdminForCurrentBucket(state),
    isAddMember: bucketSelectors.isAddMember(state),
});

const mapDispatchToProps = dispatch => ({
    onSearchChange: searchTerm =>
        dispatch({
            type: bucketConstants.CHANGE_BUCKET_MEMBERS_FILTER,
            payload: searchTerm,
        }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BucketMembersActions);



// WEBPACK FOOTER //
// ./src/containers/bucketMembers/BucketMembersActions.js